import { ThemeMode } from "../../../types";

import type { ThemeColors } from "../../../types";

export const green = {
  [ThemeMode.LIGHT]: {
    background: [1, 0, 0],
    foreground: [0.141, 0.005, 285.823],
    card: [1, 0, 0],
    "card-foreground": [0.141, 0.005, 285.823],
    popover: [1, 0, 0],
    "popover-foreground": [0.141, 0.005, 285.823],
    primary: [0.723, 0.219, 149.579],
    "primary-foreground": [0.982, 0.018, 155.826],
    secondary: [0.967, 0.001, 286.375],
    "secondary-foreground": [0.21, 0.006, 285.885],
    muted: [0.967, 0.001, 286.375],
    "muted-foreground": [0.552, 0.016, 285.938],
    accent: [0.967, 0.001, 286.375],
    "accent-foreground": [0.21, 0.006, 285.885],
    destructive: [0.577, 0.245, 27.325],
    "destructive-foreground": [0.985, 0.002, 247.839],
    success: [0.7999, 0.1816, 151.78],
    "success-foreground": [0.9848, 0, 0],
    border: [0.92, 0.004, 286.32],
    input: [0.92, 0.004, 286.32],
    ring: [0.723, 0.219, 149.579],
    "chart-1": [0.871, 0.15, 154.449],
    "chart-2": [0.723, 0.219, 149.579],
    "chart-3": [0.627, 0.194, 149.214],
    "chart-4": [0.527, 0.154, 150.069],
    "chart-5": [0.448, 0.119, 151.328],
    sidebar: [0.985, 0, 0],
    "sidebar-foreground": [0.141, 0.005, 285.823],
    "sidebar-primary": [0.723, 0.219, 149.579],
    "sidebar-primary-foreground": [0.982, 0.018, 155.826],
    "sidebar-accent": [0.967, 0.001, 286.375],
    "sidebar-accent-foreground": [0.21, 0.006, 285.885],
    "sidebar-border": [0.92, 0.004, 286.32],
    "sidebar-ring": [0.723, 0.219, 149.579],
  },
  [ThemeMode.DARK]: {
    background: [0.141, 0.005, 285.823],
    foreground: [0.985, 0, 0],
    card: [0.21, 0.006, 285.885],
    "card-foreground": [0.985, 0, 0],
    popover: [0.21, 0.006, 285.885],
    "popover-foreground": [0.985, 0, 0],
    primary: [0.696, 0.17, 162.48],
    "primary-foreground": [0.393, 0.095, 152.535],
    secondary: [0.274, 0.006, 286.033],
    "secondary-foreground": [0.985, 0, 0],
    muted: [0.274, 0.006, 286.033],
    "muted-foreground": [0.705, 0.015, 286.067],
    accent: [0.274, 0.006, 286.033],
    "accent-foreground": [0.985, 0, 0],
    destructive: [0.704, 0.191, 22.216],
    "destructive-foreground": [0.985, 0.002, 247.839],
    success: [0.627, 0.194, 149.214],
    "success-foreground": [0.985, 0, 0],
    border: [1, 0, 0, 0.1],
    input: [1, 0, 0, 0.15],
    ring: [0.527, 0.154, 150.069],
    "chart-1": [0.871, 0.15, 154.449],
    "chart-2": [0.723, 0.219, 149.579],
    "chart-3": [0.627, 0.194, 149.214],
    "chart-4": [0.527, 0.154, 150.069],
    "chart-5": [0.448, 0.119, 151.328],
    sidebar: [0.21, 0.006, 285.885],
    "sidebar-foreground": [0.985, 0, 0],
    "sidebar-primary": [0.696, 0.17, 162.48],
    "sidebar-primary-foreground": [0.393, 0.095, 152.535],
    "sidebar-accent": [0.274, 0.006, 286.033],
    "sidebar-accent-foreground": [0.985, 0, 0],
    "sidebar-border": [1, 0, 0, 0.1],
    "sidebar-ring": [0.527, 0.154, 150.069],
  },
} satisfies ThemeColors;
